(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-carrousel"] && !Shopify.designMode) return;
  try {
    
  // Délégation sur le document : l'éditeur de thème reconstruit les sections
  // à chaque réglage, un écouteur posé sur l'élément serait perdu.
  (function () {
    function piste(el) {
      return el.closest('.pcar')?.querySelector('[data-pcar-track]') || null;
    }

    function majFleches(section) {
      var track = section.querySelector('[data-pcar-track]');
      var boite = section.querySelector('[data-pcar-arrows]');
      if (!track || !boite) return;
      var deborde = track.scrollWidth - track.clientWidth > 4;
      boite.hidden = !deborde;
      if (!deborde) return;
      var x = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      section.querySelectorAll('[data-pcar-arrow]').forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-pcar-arrow'), 10);
        b.disabled = dir < 0 ? x <= 2 : x >= max - 2;
      });
    }

    function toutesLesSections() {
      document.querySelectorAll('.pcar').forEach(majFleches);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pcar-arrow]');
      if (!btn) return;
      var track = piste(btn);
      if (!track) return;
      var carte = track.querySelector('.pcar__carte');
      var pas = carte ? carte.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: pas * parseInt(btn.getAttribute('data-pcar-arrow'), 10), behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      if (e.target instanceof Element && e.target.hasAttribute('data-pcar-track')) {
        majFleches(e.target.closest('.pcar'));
      }
    }, true);

    window.addEventListener('resize', toutesLesSections);
    document.addEventListener('shopify:section:load', toutesLesSections);
    if (document.readyState !== 'loading') toutesLesSections();
    else document.addEventListener('DOMContentLoaded', toutesLesSections);
  })();

  } catch(e) { console.error(e); }
})();
})();
